var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActionproviderOverview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "110px",
    viewBox: "0 0 62 110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, -94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#386C7E",
    fillRule: "nonzero",
    x: 7.5,
    y: 0.5,
    width: 42,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "MessageParser",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400,
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 8
  }, "MessageParser")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#386C7E",
    fillRule: "nonzero",
    x: 6.5,
    y: 23.5,
    width: 42,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "ActionProvider",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400,
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 31
  }, "ActionProvider")), /*#__PURE__*/React.createElement("text", {
    id: "setState()",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400,
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    y: 75
  }, "setState()")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#386C7E",
    fillRule: "nonzero",
    x: 0.5,
    y: 46.5,
    width: 60,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#386C7E",
    fillRule: "nonzero",
    x: 1.5,
    y: 67.5,
    width: 52,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "createChatBotMessage",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 4,
    fontWeight: 400,
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4,
    y: 54
  }, "createChatBotMessage(\u201CHi\u201D)")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#376B7E",
    fill: "#376B7E",
    fillRule: "nonzero",
    cx: 25.5,
    cy: 99.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "Bot",
    fill: "#FFFFFF",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 21,
    y: 101
  }, "Bot")), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(26.000000, 36.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0 L0.5,6.68181818",
    id: "Line-7",
    stroke: "#386C7E",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-8",
    d: "M0.45,3.97777778 L0.45,3.3 L0.55,3.3 L0.55,3.97777778 L2.75,3.97777778 L0.5,8.97777778 L-1.75,3.97777778 L0.45,3.97777778 Z",
    fill: "#386C7E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(26.000000, 58.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0.5 L0.5,5.68181818",
    id: "Line-7",
    stroke: "#386C7E",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-8",
    d: "M0.45,2.97777778 L0.45,2.3 L0.55,2.3 L0.55,2.97777778 L2.75,2.97777778 L0.5,7.97777778 L-1.75,2.97777778 L0.45,2.97777778 Z",
    fill: "#386C7E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(25.000000, 80.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0.5 L0.5,5.68181818",
    id: "Line-7",
    stroke: "#386C7E",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-8",
    d: "M0.45,2.97777778 L0.45,2.3 L0.55,2.3 L0.55,2.97777778 L2.75,2.97777778 L0.5,7.97777778 L-1.75,2.97777778 L0.45,2.97777778 Z",
    fill: "#386C7E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(39.000000, 99.500000) rotate(-90.000000) translate(-39.000000, -99.500000) translate(38.500000, 95.500000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0.5 L0.5,5.68181818",
    id: "Line-7",
    stroke: "#386C7E",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-8",
    d: "M0.45,2.97777778 L0.45,2.3 L0.55,2.3 L0.55,2.97777778 L2.75,2.97777778 L0.5,7.97777778 L-1.75,2.97777778 L0.45,2.97777778 Z",
    fill: "#386C7E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(26.000000, 13.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0 L0.5,6.68181818",
    id: "Line-7",
    stroke: "#386C7E",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-8",
    d: "M0.45,3.97777778 L0.45,3.3 L0.55,3.3 L0.55,3.97777778 L2.75,3.97777778 L0.5,8.97777778 L-1.75,3.97777778 L0.45,3.97777778 Z",
    fill: "#386C7E"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1F1F1",
    fillRule: "nonzero",
    x: 43,
    y: 92,
    width: 19,
    height: 15,
    rx: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "Hi",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400,
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 46,
    y: 101
  }, "Hi")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionproviderOverview);
export default __webpack_public_path__ + "static/media/actionprovider-overview.2f89aa46f21850d108447216b2bc895a.svg";
export { ForwardRef as ReactComponent };